'use client';
function getAutoContrastValue(autoContrast, theme) {
  return typeof autoContrast === "boolean" ? autoContrast : theme.autoContrast;
}

export { getAutoContrastValue };
//# sourceMappingURL=get-auto-contrast-value.mjs.map
